module.exports = __webpack_public_path__ + "static/media/green.79b5c102.png";